import {
  INGREDIENT_RECIPES_PAGE_REQUEST,
  INGREDIENT_RECIPES_RECIPES_REQUEST,
  INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_RECIPES_EXPORT_RECIPES,
  INGREDIENT_RECIPES_ON_CLICK_ROW,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES,
  INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS,
  INGREDIENT_RECIPES_SUBMIT_FORM_CREATE,
  INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_ON_CLICK_DONE,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL,
  INGREDIENT_RECIPES_CONFIRM_SUBMIT,
  INGREDIENT_RECIPES_SET_FILTER_ITEM,
  INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST,
  INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES,
  INGREDIENT_RECIPES_DELETE_ITEM,
  INGREDIENT_RECIPES_SAVE_RECIPES,
  INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_UPDATE_RECIPES,
  INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID,
  INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID
} from 'actions/ingredients/recipes/constants'
import * as actIngredientRecipes from 'actions/ingredients/recipes'
import {put, call, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import * as act from 'actions'
import * as actLoadingSpinner from 'actions/loadingSpinner'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiIngredientRecipes from 'api/ingredients/recipes'
import * as actNotif from 'actions/notifications'
import {initialize, arrayPush, change, reset, arrayRemoveAll} from 'redux-form'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as mpIngRecipe from 'mixpanel/ingredient/recipes'
import * as _ from 'lodash'

export function * pageRequest () {
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  yield put(reset('recipes'))
  yield put(actIngredientRecipes.setOutlets([]))
  yield put(actIngredientRecipes.unSetFilterState())
  yield put(actIngredientRecipes.setRecipes([]))
  yield put(actIngredientRecipes.setRecipesDetail(null))
  yield put(actIngredientRecipes.closeRightColumn())
  yield put(act.showProgressBar())

  try {
    // get outlets
    let response = yield call(apiOutlets.outlets)
    yield put(actIngredientRecipes.setOutlets(response.data))
    let responseItem = yield call(apiIngredientRecipes.getItemDropdown)
    let formatResponseItem = []
    responseItem.data.map(function (val) {
      formatResponseItem.push({value: val.id, label: val.name, ...val})
    })
    yield put(actIngredientRecipes.setItemDropdown(formatResponseItem))
    let resProfile = yield call(apiProfile.getProfile)
    const params = {
      page: 1,
      keyword: ''
    }

    yield put(actIngredientRecipes.recipesRequest(params, []))
    yield put(initialize('search', {
      outletIds: [resProfile.data.outlet_id[0]]
    }))
    mpIngRecipe.ingredientRecipesStart({outletIds: [resProfile.data.outlet_id[0]]})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * recipesRequest (request) {
  const {payload: {params, previousRecipes}} = request
  yield put(act.showProgressBar())
  try {
    const resRecipes = yield call(apiIngredientRecipes.getRecipes, params)
    let resRecipesData = resRecipes.data
    const recipes = previousRecipes.concat(resRecipesData.results)
    yield put(actIngredientRecipes.setTotalPage(resRecipesData.meta.total_pages))
    yield put(actIngredientRecipes.setRecipes(recipes))
    yield put(actIngredientRecipes.setCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actLoadingSpinner.showPageLoadingSpinner(false))
  }
}

export function * recipesFormOnChangeOutlet () {
  yield put(change('recipes', 'recipes', []))
}

export function * recipesFormOnClickCancel () {
  yield put(actIngredientRecipes.setRecipesDetail(null))
  yield put(actIngredientRecipes.closeRightColumn())
  yield put(reset('recipes'))
}

export function * onChangeOutletIdsFlow (request) {
  const {payload: {outletIds}} = request
  mpIngRecipe.ingredientRecipesChangeFilter({outletIds})
  yield put(actIngredientRecipes.closeRightColumn())
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  yield put(actIngredientRecipes.setRecipes([]))
  yield put(actIngredientRecipes.setRecipesDetail(null))
  yield put(actIngredientRecipes.unSetFilterState())
  yield put(reset('recipes'))
  yield put(act.showProgressBar())
  try {
    yield call(apiOutlets.patchLogin, {id: outletIds})
    yield put(initialize('search', {
      outletIds
    }))
    yield put(actIngredientRecipes.pageRequest())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
  yield put(actIngredientRecipes.recipesRequest({
    page: 1
  }, []))
}

export function * exportRecipes (request) {
  const {payload: {filename, outletId, params}} = request
  try {
    let response = yield call(apiIngredientRecipes.getExportRecipes, params)
    if (response.statusText === 'OK') {
      yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Recipes'))
    } else {
      yield put(actNotif.error(response.data.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * onClickRow (request) {
  const {payload: {recipes}} = request
  mpIngRecipe.ingredientRecipesSelect({recipe: recipes})
  let {recipe_ingredients} = recipes
  let formatIngredientRecipes = []
  recipe_ingredients.map(function (recipeIngredient) {
    formatIngredientRecipes.push({
      ...recipeIngredient,
      ingredient_avg: recipeIngredient.track_cogs ? recipeIngredient.cogs * recipeIngredient.quantity : null
    })
  })
  yield put(actIngredientRecipes.setRecipesDetail(recipes))
  yield put(actIngredientRecipes.openRightColumn())
  yield put(initialize('recipes', {
    id: recipes.id,
    item_id: recipes.item_id,
    item_name: recipes.item_name,
    item_variant_name: recipes.item_variant_name || 'No Variant',
    item_variant_id: recipes.item_variant_id,
    recipe_ingredients: formatIngredientRecipes,
    ingredientsInventory: formatIngredientRecipes,
    sku: recipes.sku
  }))
}

export function * onClickCreateRecipes (request) {
  yield put(reset('recipes'))
  yield put(reset('addIngredients'))
  yield put(initialize('recipes', {
    id: null,
    item_id: null,
    item_name: null,
    item_variant_id: null,
    item_variant_name: null,
    recipe_ingredients: [],
    ingredientsInventory: []
  }))
  yield put(actIngredientRecipes.setRecipesDetail(null))
  yield put(actIngredientRecipes.setItemVariant([{value: 'Variant Option', name: 'Variant Option', is_recipe: false, isDisable: false}]))
  yield put(actIngredientRecipes.openRightColumn())
}

export function * onClickAddItems (request) {
  yield put(actIngredientRecipes.addIngredientsGetingredientRequest({
    page: 1,
    per_page: 100,
    keyword: ''
  }))
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert())
  yield put(actIngredientRecipes.showAddItemsModal())
}

export function * addIngredientsGetItemsRequestFlow (request) {
  const {payload: {params: {previousItems, ...restParams}}} = request
  if (restParams.keyword) {
    yield call(delay, 300)
  }
  try {
    yield put(actIngredientRecipes.addIngredientsShowLoading())
    let resItems = yield call(apiIngredientRecipes.getItemIngredient, restParams)
    let items = {
      results: resItems.data.results,
      total_pages: 9999,
      total_counts: 0
    }
    if (restParams.page > 1) {
      if (items.results.length === 0) {
        items.total_pages = restParams.page - 1
        items.currentPage = restParams.page - 1
      } else {
        items.currentPage = restParams.page
      }
      items.results = previousItems.concat(items.results)
    } else {
      items.currentPage = 1
    }
    yield put(actIngredientRecipes.addIngredientsSetItems(items))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actIngredientRecipes.addIngredientsHideLoading())
  }
}

export function * createRecipes () {
  // TODO
}

export function * addIngredientsOnSearchItems (request) {
  // delay to prevent too many request
  yield call(delay, 100)
  const {payload: {keyword, outletId}} = request
  yield put(actIngredientRecipes.addIngredientsGetingredientRequest({
    outlet_id: outletId,
    page: 1,
    per_page: 100,
    keyword
  }))
  yield put(initialize('addIngredients', {
  }))
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert())
}

export function * addItemVariantOnChangeItems (request) {
  const {payload: {selectedItem}} = request
  const response = yield call(apiIngredientRecipes.getItemVariant, selectedItem.value)
  let formatResponseData = []
  let responseItemVariant = response.data
  if (responseItemVariant.length) {
    if (responseItemVariant.length === 1 && !responseItemVariant[0].name) {
      formatResponseData.push({name: 'No Variant', value: responseItemVariant[0].id, isDisable: true, is_recipe: responseItemVariant[0].is_recipe, sku: responseItemVariant[0].sku})
      yield put(change('recipes', 'sku', responseItemVariant[0].sku))
    } else {
      formatResponseData.push({name: 'Variant Option', value: 'Variant Option', isDisable: false})
      responseItemVariant.map(function (item) {
        formatResponseData.push({name: item.name, value: item.id, isDisable: item.is_recipe, is_recipe: item.is_recipe, sku: item.sku})
      })
    }
  } else {
    formatResponseData.push({name: 'Variant Option', value: 'Variant Option', isDisable: true})
  }
  yield put(change('recipes', 'item_variant_id', null))
  yield put(actIngredientRecipes.setItemVariant(formatResponseData))
}

export function * onClickDone (request) {
  yield put(actIngredientRecipes.closeRightColumn())
  yield put(actIngredientRecipes.setRecipesDetail(null))
}

export function * confirmSubmit (request) {
  const {payload: {values}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientRecipes.hideConfirmSubmitModal())
    const formData = {recipes: {note: values.note, outlet_id: values.outlet_id}}
    const {recipes} = values
    formData.recipes.history_details = []
    recipes.forEach((a) => {
      if (Math.abs(parseFloat(a.quantity) - parseFloat(a.beginning_stock)) > 0.0000001) {
        formData.recipes.history_details.push({
          ...a,
          end_stock: a.quantity - a.beginning_stock,
          recipes: a.quantity - a.beginning_stock
        })
      }
    })
    yield call(apiIngredientRecipes.postRecipes, formData)
    yield put(reset('recipes'))
    yield put(actIngredientRecipes.pageRequest())
    yield put(actNotif.success('Recipes has been created'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actIngredientRecipes.closeRightColumn())
    yield put(act.hideProgressBar())
  }
}

function * setFilterRecipes (request) {
  yield call(delay, 200)
  yield put(actIngredientRecipes.setRecipes([]))
  const {payload: {keyword}} = request
  yield put(actIngredientRecipes.setFilterState(keyword))
  yield put(act.showProgressBar())
  try {
    let params = {
      page: 1,
      keyword: keyword
    }
    yield put(actIngredientRecipes.recipesRequest(params, []))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * addItemsOnSearchIngredientsModal (request) {
  yield put(actIngredientRecipes.addIngredientsSetItems([]))
  // delay to prevent too many request
  yield call(delay, 100)
  const {payload: {keyword}} = request
  yield put(actIngredientRecipes.addIngredientsGetIngredientsRequestModal({
    page: 1,
    per_page: 100,
    keyword
  }))
  yield put(initialize('addIngredients', {}))
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
  yield put(actIngredientRecipes.addIngredientsSetKeyword(keyword))
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert())
}

export function * addIngredientsOnCancelAddIngredients (request) {
  yield put(initialize('addIngredients', {
    ingredients: []
  }))
  yield put(actIngredientRecipes.hideAddIngredientsModal())
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
}

export function * addItemsOnChangeIngredientsModal (request) {
  const {payload: {ingredient, recipesForm}} = request
  const recipeIngredients = recipesForm.recipe_ingredients
  let formatQuantity = null
  let formatAvgCost = null
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
  yield put(actIngredientRecipes.addIngredientsSetIngredient(ingredient))
  yield put(change('addIngredients', 'ingredient_id', ingredient.id))
  yield put(change('addIngredients', 'ingredient_name', ingredient.name))
  yield put(change('addIngredients', 'unit_id', ingredient.unit_id))
  yield put(change('addIngredients', 'unit_name', ingredient.unit_name))
  yield put(change('addIngredients', 'cogs', ingredient.cogs))
  yield put(change('addIngredients', 'track_cogs', ingredient.track_cogs))

  if (recipeIngredients) {
    recipeIngredients.map(function (ingredientRecipe) {
      if (ingredientRecipe.ingredient_id === ingredient.id) {
        formatQuantity = ingredientRecipe.quantity
        formatAvgCost = ingredientRecipe.ingredient_avg
      }
    })
  }

  yield put(change('addIngredients', 'ingredient_avg', formatAvgCost))
  yield put(change('addIngredients', 'quantity', formatQuantity))
}

export function * addIngredientDetailRecipes (request) {
  const {payload: {values, recipesForm}} = request
  let recipeIngredients = recipesForm.recipe_ingredients
  let copyValues = [values]
  let replace = false
  if (recipeIngredients) {
    recipeIngredients.map(function (ingredient) {
      if (ingredient.ingredient_id === values.ingredient_id) {
        replace = true
      }
    })
    if (replace) {
      let newIngredientsRecipes = recipeIngredients.map(obj => copyValues.find(o => o.ingredient_id === obj.ingredient_id) || obj)
      yield put(arrayRemoveAll('recipes', 'recipe_ingredients'))
      for (var i = 0; i < newIngredientsRecipes.length; i++) {
        yield put(arrayPush('recipes', 'recipe_ingredients', newIngredientsRecipes[i]))
      }
    } else {
      yield put(arrayPush('recipes', 'recipe_ingredients', values))
    }
  } else {
    yield put(arrayPush('recipes', 'recipe_ingredients', values))
  }

  yield put(actIngredientRecipes.hideAddIngredientsModal())
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null))
}

export function * deleteItem (request) {
  const {payload: {recipe, previousRecipes}} = request
  try {
    mpIngRecipe.ingredientRecipesDelete({recipe})
    yield put(act.showProgressBar())
    // remove items
    let deletedIndex = -1
    previousRecipes.forEach((pRecipes, index) => {
      if (pRecipes.id === recipe.id) {
        deletedIndex = index
      }
    })
    if (deletedIndex !== -1) {
      previousRecipes.splice(deletedIndex, 1)
    }
    yield call(apiIngredientRecipes.deleteRecipesById, recipe.id)
    yield put(actIngredientRecipes.closeRightColumn())
    yield put(actIngredientRecipes.setRecipesDetail(null))
    yield put(actIngredientRecipes.hideDeleteModal())
    yield put(reset('recipes'))
    yield put(actNotif.success('Recipes was successfully removed.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onSaveRecipes (request) {
  const {payload: {recipe, previousRecipes}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(true))
    mpIngRecipe.ingredientRecipesCreate({recipe, allOutlet: false})
    let responseCreateRecipes = yield call(apiIngredientRecipes.createRecipes, recipe)
    let updatedRecipes = responseCreateRecipes.data
    previousRecipes.unshift(updatedRecipes)
    yield put(initialize('recipes', recipe))
    yield put(actIngredientRecipes.setRecipes(previousRecipes))
    yield put(reset('recipes'))
    let newIngredientsInventory = [...recipe.recipe_ingredients]
    _.forEach(newIngredientsInventory, (val) => {
      _.forEach(updatedRecipes.recipe_ingredients, (val2) => {
        if (val2.ingredient_id === val.ingredient_id) {
          val['in_stock'] = val2.in_stock
        }
      })
    })
    yield put(initialize('recipes', {
      id: responseCreateRecipes.data.id,
      item_id: recipe.item_id,
      item_name: recipe.item_name,
      item_variant_name: recipe.item_variant_name || 'No Variant',
      item_variant_id: recipe.item_variant_id,
      recipe_ingredients: newIngredientsInventory,
      ingredientsInventory: newIngredientsInventory
    }))
    yield put(actIngredientRecipes.setRecipesDetail(responseCreateRecipes.data))
    yield put(actNotif.success('Recipes was successfully saved.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(false))
  }
}

export function * onSaveRecipesAllOutlet (request) {
  const {payload: {recipe, previousRecipes}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(true))
    mpIngRecipe.ingredientRecipesCreate({recipe, allOutlet: true})
    let responseCreateRecipes = yield call(apiIngredientRecipes.createRecipesAllOutlet, recipe)
    let responseData = responseCreateRecipes.data
    let newRecipes = responseData.current_recipe
    if (responseData.outlet_success && responseData.outlet_success.length > 0) {
      yield put(actIngredientRecipes.setCreatedOutlets({
        outletsFailed: responseData.outlet_failed,
        outletsSuccess: responseData.outlet_success
      }))
      yield put(reset('recipes'))
      if (newRecipes) {
        let newIngredientsInventory = [...recipe.recipe_ingredients]
        _.forEach(newIngredientsInventory, (val) => {
          _.forEach(newRecipes.recipe_ingredients, (val2) => {
            if (val2.ingredient_id === val.ingredient_id) {
              val['in_stock'] = val2.in_stock
            }
          })
        })
        previousRecipes.unshift(newRecipes)
        yield put(actIngredientRecipes.setRecipes(previousRecipes))
        yield put(initialize('recipes', {
          id: newRecipes.id,
          item_id: recipe.item_id,
          item_name: recipe.item_name,
          item_variant_name: recipe.item_variant_name || 'No Variant',
          item_variant_id: recipe.item_variant_id,
          recipe_ingredients: newIngredientsInventory,
          ingredientsInventory: newIngredientsInventory
        }))
        yield put(actIngredientRecipes.setRecipesDetail(newRecipes))
      } else {
        yield put(actIngredientRecipes.closeRightColumn())
      }
      yield put(actIngredientRecipes.showSaveToAllOutletsModal())
    } else {
      yield put(actNotif.error('Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).'))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actIngredientRecipes.isSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * onUpdateRecipes (request) {
  const {payload: {recipe, previousRecipes}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(true))
    let responseUpdateRecipes = yield call(apiIngredientRecipes.updateRecipes, recipe.id, recipe)
    let newRecipes = responseUpdateRecipes.data
    previousRecipes.forEach((previousRecipe, index) => {
      if (newRecipes.id === previousRecipe.id) {
        previousRecipes[index] = {...newRecipes}
      }
    })
    yield put(initialize('recipes', recipe))
    yield put(actIngredientRecipes.setRecipes(previousRecipes))
    yield put(reset('recipes'))
    yield put(initialize('recipes', {
      id: newRecipes.id,
      item_id: recipe.item_id,
      item_name: recipe.item_name,
      item_variant_name: recipe.item_variant_name || 'No Variant',
      item_variant_id: recipe.item_variant_id,
      recipe_ingredients: recipe.recipe_ingredients,
      ingredientsInventory: recipe.recipe_ingredients
    }))
    yield put(actIngredientRecipes.setRecipesDetail(newRecipes))
    yield put(actNotif.success('Recipes was successfully updated.'))
    yield put(actIngredientRecipes.onClickRow(newRecipes))
    mpIngRecipe.ingredientRecipesUpdate({recipe})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(false))
  }
}

export function * onUpdateRecipesAllOutlet (request) {
  const {payload: {recipe, previousRecipes}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(true))
    let responseUpdateRecipes = yield call(apiIngredientRecipes.updateRecipesAllOutlet, recipe.id, recipe)
    let responseData = responseUpdateRecipes.data
    if (responseData.outlet_success && responseData.outlet_success.length > 0) {
      yield put(actIngredientRecipes.setCreatedOutlets({
        outletsFailed: responseData.outlet_failed,
        outletsSuccess: responseData.outlet_success
      }))
      yield put(reset('recipes'))
      yield put(actIngredientRecipes.showSaveToAllOutletsModal())
      let updatedRecipes = responseData.current_recipe
      if (updatedRecipes) {
        previousRecipes.forEach((previousRecipe, index) => {
          if (updatedRecipes.id === previousRecipe.id) {
            previousRecipes[index] = {...updatedRecipes}
          }
        })
        yield put(actIngredientRecipes.setRecipes(previousRecipes))
        yield put(initialize('recipes', {
          id: updatedRecipes.id,
          item_id: recipe.item_id,
          item_name: recipe.item_name,
          item_variant_name: recipe.item_variant_name || 'No Variant',
          item_variant_id: recipe.item_variant_id,
          recipe_ingredients: recipe.recipe_ingredients,
          ingredientsInventory: recipe.recipe_ingredients
        }))
        yield put(actIngredientRecipes.setRecipesDetail(updatedRecipes))
      } else {
        yield put(actIngredientRecipes.closeRightColumn())
      }
    } else {
      yield put(actNotif.error('Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).'))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actIngredientRecipes.isSubmittingForm(false))
  }
}

export function * setIngredientByVariantId (request) {
  const {payload: {itemVariant, recipesForm, selectedVariant}} = request
  try {
    yield put(act.showProgressBar())
    let response = yield call(apiIngredientRecipes.getRecipesByVariantId, itemVariant.value)
    let recipe = response.data
    let recipeIngredient = recipe.recipe_ingredients
    let formatIngredientRecipes = []
    recipeIngredient.map(function (ing) {
      formatIngredientRecipes.push({
        ingredient_id: ing.ingredient_id,
        ingredient_name: ing.ingredient_name,
        quantity: ing.quantity,
        unit_name: ing.unit_name,
        ingredient_avg: ing.track_cogs ? ing.cogs * ing.quantity : null,
        in_stock: ing.in_stock,
        cogs: ing.cogs,
        track_cogs: ing.track_cogs,
        recipe_id: ing.recipe_id,
        unit_id: ing.unit_id
      })
    })
    yield put(initialize('recipes', {
      item_id: recipesForm.item_id,
      item_name: recipesForm.item_name,
      item_variant_id: selectedVariant,
      item_variant_name: recipesForm.item_variant_name,
      recipe_ingredients: formatIngredientRecipes
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * unSetIngredientByItemVariant () {
  yield put(act.showProgressBar())
  yield put(arrayRemoveAll('recipes', 'recipe_ingredients'))
  yield put(act.hideProgressBar())
}

export default function * saga () {
  yield takeLatest(INGREDIENT_RECIPES_PAGE_REQUEST, pageRequest)
  yield takeLatest(INGREDIENT_RECIPES_RECIPES_REQUEST, recipesRequest)
  yield takeLatest(INGREDIENT_RECIPES_SET_FILTER_ITEM, setFilterRecipes)
  yield takeLatest(INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow)
  yield takeLatest(INGREDIENT_RECIPES_EXPORT_RECIPES, exportRecipes)
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_ROW, onClickRow)
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES, onClickCreateRecipes)
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS, onClickAddItems)
  yield takeLatest(INGREDIENT_RECIPES_SUBMIT_FORM_CREATE, createRecipes)
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_DONE, onClickDone)
  yield takeLatest(INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET, recipesFormOnChangeOutlet)
  yield takeLatest(INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL, recipesFormOnClickCancel)
  yield takeLatest(INGREDIENT_RECIPES_CONFIRM_SUBMIT, confirmSubmit)
  yield takeLatest(INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST, addIngredientsGetItemsRequestFlow)
  yield takeLatest(INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS, addIngredientsOnSearchItems)
  yield takeLatest(INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS, addItemVariantOnChangeItems)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS, addItemsOnChangeIngredientsModal)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS, addItemsOnSearchIngredientsModal)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS, addIngredientsOnCancelAddIngredients)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT, confirmSubmit)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST, addIngredientsGetItemsRequestFlow)
  yield takeLatest(INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS, addItemsOnChangeIngredientsModal)
  yield takeLatest(INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES, addIngredientDetailRecipes)
  yield takeLatest(INGREDIENT_RECIPES_DELETE_ITEM, deleteItem)
  yield takeLatest(INGREDIENT_RECIPES_SAVE_RECIPES, onSaveRecipes)
  yield takeLatest(INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET, onSaveRecipesAllOutlet)
  yield takeLatest(INGREDIENT_RECIPES_UPDATE_RECIPES, onUpdateRecipes)
  yield takeLatest(INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET, onUpdateRecipesAllOutlet)
  yield takeLatest(INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID, setIngredientByVariantId)
  yield takeLatest(INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID, unSetIngredientByItemVariant)
}



// WEBPACK FOOTER //
// ./app/sagas/ingredients/recipes.js